<span class="readonly-badge">
  <ix-icon name="lock"></ix-icon>
  <span>
    {{ 'readonly' | translate }}
  </span>
</span>
